import { Pipe, PipeTransform } from '@angular/core';
import {CalendarService} from "../../calendar.service";

@Pipe({
  name: 'badgeStatus'
})
export class BadgeStatusPipe implements PipeTransform {
  constructor( private service: CalendarService){}

  transform(statusName: string, ...args: unknown[]): string {
    return this.service.getClassByStatusName(statusName);
  }
}
